import React from 'react';

import ai from '../../assets/ai.png';
import './header.css';

const Header = () => (
  <div className="gpt3__header section__padding" id="home">
    <div className="gpt3__header-content">
      <h1 className="gradient__text">ANECDOTES OF LITERARY TRAVERSAL</h1>
      <p>We are here to produce outstanding works, expressed as streams of freely 
        flowing written thoughts, that grapple to unlock the call of our time, bestowing tangible improvements 
        on humanity. This is the exit from the current creativity impasse. </p>

     {/*<div className="gpt3__header-content__input">
        <input type="email" placeholder="Your Email Address" />
        <button type="button">Get Started</button>
      </div>

      <div className="gpt3__header-content__people">
        <img src={people} alt='banner'/>
        <p>Over 1.6k people visit this site on a daily basis.</p>
</div>*/}
    </div>

    <div className="gpt3__header-image">
      <img src={ai} alt='banner' />
    </div>
  </div>
);

export default Header;